import { StyledComponent } from "@emotion/styled";
import { Link, Text, theme } from "@xometry/xometry_loft";
import { useContextSelector } from "use-context-selector";
import { PfsFile } from "../../schema/generated/schema";
import fileUtils from "../../utils/fileUtils";
import { useConfig } from "../proposals/contexts/configContext";
import { ScreenSizeContext } from "../proposals/contexts/screenSizeContext";

const FileDownloadLink: React.FC<{ file: PfsFile; disableLink: boolean }> = ({
  file,
  disableLink,
  ...props
}) => {
  const { isHeadless } = useConfig();
  const isSmallScreen = useContextSelector(
    ScreenSizeContext,
    ctx => ctx.isSmallScreen
  );
  let Component: StyledComponent<any> = Text;
  const componentProps: Record<string, unknown> = {};
  const { origins } = useConfig();

  if (!isSmallScreen && !isHeadless && !disableLink) {
    Component = Link;
    componentProps.href = fileUtils.buildDownloadUrl(origins, file);
    componentProps.target = "_blank";
  }

  const originalFilename = fileUtils.getOriginalFilename(file);
  componentProps.title = originalFilename;

  return (
    <Component
      fontSize={theme.fontSizes[0]}
      fontWeight={theme.fontWeights.semibold}
      marginRight={theme.space[2]}
      {...props}
      {...componentProps}
    >
      {originalFilename}
    </Component>
  );
};

export default FileDownloadLink;
